import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/site/HomePage";
import StoryPage from "@/site/StoryPage";

// The public site: the same stories as the apps, read from the content server (src/site/content.ts).
// The old web app and its admin are gone from here; the content is made with the scripts and TapVocab Outliner.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/story/:slug/:n?" element={<StoryPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
